module.exports = "/_next/static/images/Iso27001Badge@2x-25f4f13de768df2d7d948d485acb390f.png";